import { render, staticRenderFns } from "./department_add.vue?vue&type=template&id=95dfcb74&scoped=true&"
import script from "./department_add.vue?vue&type=script&lang=js&"
export * from "./department_add.vue?vue&type=script&lang=js&"
import style0 from "./department_add.vue?vue&type=style&index=0&id=95dfcb74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dfcb74",
  null
  
)

export default component.exports